(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Cosine-driven wave: peak at entry, zero at center (in-place reading), peak (flipped) at exit
  var AMP = 20; // px — peak offset at viewport entry / exit
  var SELECTOR = [
    '.collection-list .collection-list__item',
    'body.template-index .product-grid > li',
    'body.template-index .product-grid > .grid__item',
    '.product-recommendations .grid__item',
    'product-recommendations .grid__item'
  ].join(',');

  function colOf(card) {
    var grid = card.parentElement;
    if (!grid) return 0;
    var w = window.innerWidth;
    var cls = grid.className || '';
    var pick = function (re) { var m = cls.match(re); return m ? parseInt(m[1], 10) : null; };
    var cols;
    if (w >= 990) cols = pick(/grid--(\d+)-col-desktop/) || pick(/grid--(\d+)-col-tablet/);
    else if (w >= 750) cols = pick(/grid--(\d+)-col-tablet(?!-down)/) || pick(/grid--(\d+)-col-tablet-down/);
    else cols = pick(/grid--(\d+)-col-tablet-down/) || pick(/grid--(\d+)-col-tablet/);
    if (!cols || cols < 1) cols = 1;
    var idx = Array.prototype.indexOf.call(grid.children, card);
    return { col: idx % cols, cols: cols };
  }

  var attached = new WeakSet();

  function attachWave(card) {
    if (attached.has(card)) return;
    attached.add(card);

    var info = colOf(card);
    // Single-column rows: skip wave (no neighbours to wave against)
    if (info.cols < 2) return;

    var dir = info.col % 2 === 0 ? -1 : 1; // even cols sit up (-Y), odd sit down (+Y)

    // Drop Dawn's slide-in animation (animation-fill-mode:forwards otherwise
    // pins transform:translateY(0) and overrides our inline transform).
    card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
    card.style.animation = 'none';
    card.style.transition = 'none';
    card.style.willChange = 'transform';

    // cos(progress * PI) gives 1 → 0 → -1 as progress goes 0 → 0.5 → 1.
    // Entry: dir*AMP. Center (in-place): 0 (perfect alignment). Exit: -dir*AMP (wave inverts).
    var st = window.ScrollTrigger.create({
      trigger: card,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 0.3,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        var wave = Math.cos(self.progress * Math.PI); // 1..-1
        window.gsap.set(card, { y: dir * AMP * wave });
      }
    });
    return st;
  }

  function attachAll() {
    var cards = document.querySelectorAll(SELECTOR);
    cards.forEach(attachWave);
  }

  function start() {
    if (!window.gsap || !window.ScrollTrigger) return setTimeout(start, 60);
    window.gsap.registerPlugin(window.ScrollTrigger);
    attachAll();

    // Pick up cards injected later (AJAX recommendations, section reloads, etc.)
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function (muts) {
        var any = false;
        muts.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches(SELECTOR)) { attachWave(n); any = true; }
            if (n.querySelectorAll) n.querySelectorAll(SELECTOR).forEach(function (c) { attachWave(c); any = true; });
          });
        });
        if (any) window.ScrollTrigger.refresh();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    // Recompute on viewport changes (column counts can flip)
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { window.ScrollTrigger.refresh(); }, 120);
    });

    // Shopify theme editor: re-bind after section reload
    document.addEventListener('shopify:section:load', function () { attachAll(); window.ScrollTrigger.refresh(); });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
